import React, { useContext, useState, useEffect } from "react";
import "./SettingsDisplay.scss";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";
import { FileEarmarkBreak } from "react-bootstrap-icons";
import ImageUploader from "react-images-upload";
import { Button } from "react-bootstrap";
import { ToastContainer } from "react-toastify";

import { UserContext } from "../../api/user/userContext";
import AvatarDialog from "./AvatarDialog";
import { Avatars } from "../../api/ReplayVariables";

function SettingsDisplay({ onLogin = () => {} }) {
  const { user, dispatchUser } = useContext(UserContext);
  const [ready, setReady] = useState(false);

  const [bannerChanged, setBannerChanged] = useState(false);
  const [bannerImage, setBannerImage] = useState(null);
  const [bannerFile, setBannerFile] = useState(null);

  const [avatarChanged, setAvatarChanged] = useState(false);
  const [avatarImage, setAvatarImage] = useState(null);
  const [avatarFile, setAvatarFile] = useState(null);
  const [avatarGallery, setAvatarGallery] = useState(null);

  const [showGallery, setShowGallery] = useState(false);

  const { t } = useTranslation();

  const handleBannerSubmit = (event) => {
    event.preventDefault();
    setReady(false);

    const data = new FormData();
    data.append("file", bannerFile);
    axios
      .post(window.serverUrl+`/social/canvas.php`, data, {})
      .then((resp) => {
        let data = resp.data;
        if (data.error === 401) {
          onLogin();
        } else {
          setBannerChanged(false);
          dispatchUser({ type: "canvas", payload: data.file });
        }
        setReady(true);
      })
      .catch((err) => {
        console.error("fetch problem", err);
        setReady(true);
        toast.error(t("settings.update_error"), {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: 0
        });
      });
  };

  const bannerSelected = (image) => {
    console.log("image", image);
    if (image.length === 1) {
      var img = document.createElement("img");

      img.onload = function () {
        console.log("size", this.width + " " + this.height);
        if (this.width >= 2048 && this.height >= 335) {
          setBannerImage(img.src);
          setBannerChanged(true);
          setBannerFile(image[0]);
        } else {
          toast.error(t("settings.banner_size_error"), {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: 0
          });
        }
      };

      var reader = new FileReader();
      reader.onloadend = function (ended) {
        img.src = ended.target.result;
      };
      reader.readAsDataURL(image[0]);
    } else {
      toast.error(t("settings.banner_weight_error"), {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: 0
      });
    }
  };

  const cancelBanner = () => {
    setBannerImage(null);
    setAvatarChanged(false);
  };

  const handleAvatarSubmit = (event) => {
    event.preventDefault();
    setReady(false);

    const data = new FormData();
    if (avatarFile !== null) {
      data.append("file", avatarFile);
    } else {
      data.append("gallery", avatarGallery);
    }
    axios
      .post(window.serverUrl+`/social/avatar.php`, data, {})
      .then((resp) => {
        let data = resp.data;
        if (data.error === 401) {
          onLogin();
        } else {
          setAvatarChanged(false);
          dispatchUser({ type: "avatar", payload: data.file });
        }
        setReady(true);
      })
      .catch((err) => {
        console.error("fetch problem", err);
        setReady(true);
        toast.error(t("settings.update_error"), {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: 0
        });
      });
  };

  const avatarSelected = (image) => {
    console.log("image", image);
    if (image.length === 1) {
      var img = document.createElement("img");

      img.onload = function () {
        console.log("size", this.width + " " + this.height);
        if (this.width === this.height && this.width >= 128) {
          setAvatarImage(img.src);
          setAvatarChanged(true);
          setAvatarFile(image[0]);
          setAvatarGallery(null);
        } else {
          toast.error(t("settings.avatar_size_error"), {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: 0
          });
        }
      };

      var reader = new FileReader();
      reader.onloadend = function (ended) {
        img.src = ended.target.result;
      };
      reader.readAsDataURL(image[0]);
    } else {
      toast.error(t("settings.avatar_weight_error"), {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: 0
      });
    }
  };

  const onGalleySelection = (letter) => {
    var img = document.createElement("img");
    setShowGallery(false);
    img.onload = function () {
      console.log("size", this.width + " " + this.height);
      setAvatarImage(img.src);
      setAvatarChanged(true);
      setAvatarFile(null);
      setAvatarGallery(letter);
    };

    img.src =
      window.serverUrl+"/media/kunena/avatars/gallery/avatar_" +
      letter +
      ".png";
  };

  const cancelAvatar = () => {
    setAvatarImage(null);
    setAvatarChanged(false);
  };

  const letters = [
    "a",
    "z",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "q",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "m",
    "w",
    "x",
    "c",
    "v",
    "b",
    "n"
  ];

  const getAvatar = (pseudo) => {
    let letter = pseudo.substring(0, 1).toLowerCase();
    if (letters.indexOf(letter) !== -1) {
      return Avatars["avatar" + letter.toUpperCase()];
    } else {
      return Avatars.avatarA;
    }
  };
  useEffect(() => {
    //console.log("settings infos effect", user);
    if (user.error !== 401) {
      if (bannerImage === null) {
        let img = document.createElement("img");
        img.style.display = "none";
        document.body.appendChild(img);

        img.onload = function () {
          if (this !== null && this.width >= 2048 && this.height >= 335) {
            setBannerImage(img.src);
          } else {
            console.error("canvas too small");
            //setBannerImage(img.src);
            setBannerImage(null);
          }
          setReady(true);
          document.body.removeChild(img);
        };
        img.onerror = (e) => {
          console.error(e);
          setBannerImage(null);
          setReady(true);
          document.body.removeChild(img);
        };

        img.src = window.serverUrl+"/images/comprofiler/" + user.canvas;
      }
      if (avatarImage === null) {
        let img = document.createElement("img");
        img.style.display = "none";
        document.body.appendChild(img);

        img.onload = function () {
          if (
            this !== null &&
            this.width === this.height &&
            this.width >= 128
          ) {
            setAvatarImage(img.src);
          } else {
            console.error("avatar too small");
            //setBannerImage(img.src);
            setAvatarImage(null);
          }
          setReady(true);
          document.body.removeChild(img);
        };
        img.onerror = (e) => {
          console.error(e);
          setAvatarImage(null);
          setReady(true);
          document.body.removeChild(img);
        };
        if (user.avatar)
        {
          img.src =
            window.serverUrl + "/media/kunena/avatars/" +
            user.avatar +
            "?t=" +
            Math.random();
        }
      }
    }
  }, [user, bannerImage, avatarImage, dispatchUser]);

  return (
    <>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
      />
      <form
        onSubmit={handleBannerSubmit}
        className={
          "settings-display separator d-flex " + (ready ? "ready" : "")
        }
      >
        <div className="infos-container d-flex flex-column">
          <section>{t("settings.banner")}</section>
          <div className="banner-container">
            <div className="banner-image">
              {bannerImage === null ||
              bannerImage === undefined ||
              bannerImage.trim() === "" ? (
                <FileEarmarkBreak />
              ) : (
                <>
                  <img src={bannerImage} alt="" />
                </>
              )}
            </div>
            <div className="infos-description">
              {t("settings.banner_text")}
              <div className="actions">
                {bannerImage !== null &&
                bannerImage !== undefined &&
                bannerChanged ? (
                  <>
                    <Button className="cancel" onClick={cancelBanner}>
                      {t("replayApp.cancel")}
                    </Button>
                    <Button className="update" type="submit">
                      {t("settings.update")}
                    </Button>
                  </>
                ) : (
                  <ImageUploader
                    className="upload"
                    withIcon={false}
                    buttonText={t(
                      bannerImage === null ||
                        bannerImage === undefined ||
                        bannerImage === ""
                        ? "settings.upload"
                        : "settings.change"
                    )}
                    onChange={bannerSelected}
                    imgExtension={[".jpg", ".gif", ".png", ".gif"]}
                    maxFileSize={20000000}
                    singleImage={true}
                    withPreview={false}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
      <form
        onSubmit={handleAvatarSubmit}
        className={"settings-display d-flex " + (ready ? "ready" : "")}
      >
        <div className="infos-container d-flex flex-column">
          <section>{t("settings.avatar")}</section>
          <div className="avatar-container">
            <div className="avatar-image">
              {avatarImage === null ||
              avatarImage === undefined ||
              avatarImage.trim() === "" ? (
                user.avatar ? (
                  <img
                    className="avatar"
                    src={
                      window.serverUrl+"/media/kunena/avatars/" +
                      user.avatar
                    }
                    alt="avatar"
                  />
                ) : user !== null && user.error !== 401 ? (
                  <img
                    className="avatar"
                    src={getAvatar(user.username)}
                    alt=""
                  />
                ) : (
                  <></>
                )
              ) : (
                <>
                  <img src={avatarImage} alt="" />
                </>
              )}
            </div>
            <div className="infos-description">
              {t("settings.avatar_text")}
              <div className="actions">
                {avatarImage !== null &&
                avatarImage !== undefined &&
                avatarChanged ? (
                  <>
                    <Button className="cancel" onClick={cancelAvatar}>
                      {t("replayApp.cancel")}
                    </Button>
                    <Button className="update" type="submit">
                      {t("settings.update")}
                    </Button>
                  </>
                ) : (
                  <>
                    <ImageUploader
                      className="upload"
                      withIcon={false}
                      buttonText={t("settings.upload")}
                      onChange={avatarSelected}
                      imgExtension={[".jpg", ".gif", ".png", ".gif"]}
                      maxFileSize={5000000}
                      singleImage={true}
                      withPreview={false}
                    />
                    <Button
                      className="gallery-button"
                      onClick={() => {
                        setShowGallery(true);
                      }}
                    >
                      {t("settings.gallery")}
                    </Button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
      <AvatarDialog
        show={showGallery}
        onAvatarSelected={onGalleySelection}
        handleClose={() => {
          setShowGallery(false);
        }}
      ></AvatarDialog>
    </>
  );
}

export default SettingsDisplay;
